export default "__VITE_ASSET__DKVaqd0t__"